import type { Room } from "building-types/rooms/roomTypes";

export function roomOpenToBelow(room: Room) {
  return room.attributes.openToBelow && room.level.levelBelow !== undefined;
}

export function roomOpenToAbove(room: Room) {
  return room.attributes.openToAbove && room.level.levelAbove !== undefined;
}

export function roomRemoveFloorStructure(room: Room) {
  return !!room.attributes.removeFloorStructure;
}
